var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{staticClass:"login-page",scopedSlots:_vm._u([{key:"logo",fn:function(){return [_c('img',{staticClass:"login-logo",attrs:{"alt":"Easter Seals NB","src":require("../../assets/logo.svg")}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }